import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";
import DatePickerInput from "../Datepicker";
import Textarea from "../Textarea";
import Button from "../Button";

interface Props {
  today: Date;
  onBlockDateClose: any;
  onBlockDate: any;
  data: any;
  onDateDataChange: any;
}

const BlockDateModal = ({
  today,
  onBlockDateClose,
  onBlockDate,
  data,
  onDateDataChange,
}: Props) => {
  return (
    <Modal setOpenOrClose={onBlockDateClose} variant={"none"} width="21.2rem">
      <div style={{ padding: "1.5rem 1rem", flexDirection: "column" }}>
        <BlockDateHeader>
          <HeaderTitle>Blocked Date</HeaderTitle>
          <Close
            src={require("../../assets/images/ei_close.png")}
            alt="close"
            onClick={onBlockDateClose}
          />
        </BlockDateHeader>
        <BlockDateBody>
          <DateContainer>
            <Label>From Date</Label>
            <DatePickerInput
              //@ts-ignore
              outlined={true}
              value={data?.fromDate}
              width="15.75rem"
              minDate={today}
              onChange={(e) =>
                onDateDataChange({ target: { value: e, name: "fromDate" } })
              }
            />
          </DateContainer>
          <Textarea
            name="comment"
            placeholder="Comments"
            onChange={(e) => onDateDataChange(e)}
            value={data?.comment}
            required
            label="Comments"
          />
          <ButtonWrapper>
            <Button
              label="Submit"
              variant="filled"
              width="100%"
              color={Colors.red}
              onClick={onBlockDate}
            />
          </ButtonWrapper>
        </BlockDateBody>
      </div>
    </Modal>
  );
};

const ButtonWrapper = styled.label`
  margin-top: 1rem;
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1rem;
`;

const DateContainer = styled.div`
  margin: 1rem 0;
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-size: 0.8rem;
  color: ${Colors.comet};
  margin-top: 1.5rem;
`;

const BlockDateBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.25rem;
  //   gap:0.5rem;
`;

const BlockDateHeader = styled.div`
  display: flex;
  justify-content: center;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
`;

export default BlockDateModal;
